import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const ModalTitle = ({ id, label }) => {
  const labelElm = label ? <span>{label}</span> : <FormattedMessage id={id} />

  return (
    <h1 id={id} className="tl f4 normal c-on-base ma0 mb6 min-w5">
      {labelElm}
    </h1>
  )
}

ModalTitle.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
}

export default ModalTitle
